import { useMemo } from "react";

import type { ChipItem } from "app/pages/sales-intelligence/common-components/filters-panel";
import { LimitedChipItems } from "app/pages/sales-intelligence/common-components/filters-panel";
import { FilterResultContainer } from "app/pages/sales-intelligence/common-components/filters-panel/components/styles";
import { MAX_CHIPS_GROUP_AMOUNT } from "app/pages/sales-intelligence/common-components/filters-panel/constants";
import { EMPTY_ARRAY } from "app/pages/sales-intelligence/constants/common";

import type { IFilterViewBaseModelProps } from "../../../types/filterInstance";
import type { DynamicComboboxFilterOptions } from "../../../types/filterOptions";
import { composeFieldChipLabel, resolveOptionLabel } from "../../../utils/filterOptions";

const EnumArrayComboboxFilterResult = ({
    filter,
    value = EMPTY_ARRAY,
    isExpanded,
    isActionEnabled = true,
    onFilterUpdate,
}: IFilterViewBaseModelProps<readonly string[], DynamicComboboxFilterOptions>) => {
    const handleRemove = (id: string): void => {
        onFilterUpdate(value.filter((v) => v !== id));
    };

    const chipItems = useMemo(
        (): ChipItem[] =>
            value.map((id) => ({
                id,
                text: composeFieldChipLabel(filter.options.label, resolveOptionLabel(filter.options.options, id)),
            })),
        [value, filter.options.label, filter.options.options],
    );

    if (chipItems.length === 0) {
        return null;
    }

    return (
        <FilterResultContainer>
            <LimitedChipItems
                items={chipItems}
                onDelete={handleRemove}
                maxItems={MAX_CHIPS_GROUP_AMOUNT}
                hideActionButton={!isActionEnabled}
                isTabExpanded={isExpanded}
            />
        </FilterResultContainer>
    );
};

export default EnumArrayComboboxFilterResult;
